document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.flip.flip-on-click').forEach(card => {
        card.addEventListener('click', (e) => {
            e.stopPropagation();
            if (card.classList.contains('flipped')) {
                card.classList.remove('flipped');
                card.classList.add('slow-leave');
            } else {
                card.classList.add('flipped');
                card.classList.remove('slow-leave');
            }
        });
    });
    document.addEventListener('click', (e) => {
        document.querySelectorAll('.flip.flip-on-click.flipped').forEach(card => {
            if (!card.contains(e.target)) {
                card.classList.remove('flipped');
                card.classList.add('slow-leave');
            }
        });
    });
});


